var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.9 42.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#49a671",
    d: "M21.45,0C9.6,0,0,9.6,0,21.45s9.6,21.45,21.45,21.45,21.45-9.6,21.45-21.45S33.29,0,21.45,0ZM35.1,14.13l-14.89,15.35-2.55,2.62c-.26.26-.68.26-.94.01l-2.68-2.59-6.21-6.08c-.68-.66-.69-1.75-.03-2.43l.63-.64c.66-.68,1.75-.69,2.42-.03l5.75,5.61c.26.25.67.25.92-.01l14.47-14.83c.66-.68,1.75-.69,2.42-.03l.64.62c.68.66.69,1.75.03,2.42Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green-tick.55728621276b2f5cbaa37d9b161f42f3.svg";
export { ForwardRef as ReactComponent };